import { React, useState, useEffect } from 'react';
import './header.css';
import { Navigate, useLocation, useNavigate, useNavigation } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import { logout } from '../../../Redux/actions';
import { useSelector } from 'react-redux';
import { getName, getProfile, getUserName } from '../../../Redux/selecters';
import { RiShutDownLine } from 'react-icons/ri';
const Header = ({ Currency }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userName = useSelector(getName);
  const image = useSelector(getProfile);

  const handleOut = () => {
    dispatch(logout());
    localStorage.clear();
    // navigate('/Login')
    window.location.href = 'https://app.pro360erp.com';

    window.location.reload(false);
  };
  const UserName = userName?.length > 20 ? userName.substring(0, 10) + '...' : userName;

  return (
    <nav class="navbar-expand-lg  invHead ">
      <div class="container-fluid">
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse d-flex end gap-4" id="navbarSupportedContent">
          <div className="end col-4 d-flex gap-2">
            <div className="center">Financial Year</div>
            <Select
              isSearchable={false}
              defaultValue={{ label: 'Financial Years 2023', value: 'Financial Years 2023' }}
              // options={currency}
              className="w-50 p-0"
              theme={(theme) => ({
                ...theme,
                borderRadius: 8,
                padding: 9,
              })}
            />
          </div>
          <div className="end col-3">
            <Select
              isSearchable={false}
              defaultValue={{ label: 'Select Company', value: 'Financial Years 2023' }}
              // options={currency}
              className="w-75 p-0"
              theme={(theme) => ({
                ...theme,
                borderRadius: 8,
                padding: 9,
              })}
            />
          </div>
          <div className="d-flex gap-2">
            <div className="InvProfile dropdown">
              {UserName || 'Admin'}
              <div className="dropdown-content-stats pt-1">
                <Link to="/admin/Setting/Profile" className="p-2">
                  Setting
                </Link>
                <Link onClick={handleOut} className="p-2">
                  Log Out
                </Link>
              </div>
            </div>
            <div className="invprofileimg">{image ? <img src={image} className="Invboxicon" /> : <RiShutDownLine size={30} />}</div>
          </div>
        </div>
      </div>
    </nav>
  );
};

const mapStatetoProps = (state) => state;
export default connect(mapStatetoProps)(Header);
